import { IconButton } from '@mui/material';
import { increaseOtrView, updateOtr } from 'APIs/HotAuctionApi';
import { useAppDispatch, useAppSelector } from 'app/hooks';
import { selectAuth } from 'features/auth/authSlice';
import { addLike, selectOtr } from 'features/auth/otrSlice';
import useLongPress from 'hooks/onLongPress';
import React, { SetStateAction, useEffect, useRef, useState } from 'react';
import { useSwipeable } from 'react-swipeable';
import './style.css';
import VideoSidebar from './MobileOtrSidebar';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import { useNavigate } from 'react-router-dom';
import { Grid } from '@mui/material';
import { OtrData } from 'interfaces/OtrData.interface';
import { NormalButton } from 'components/atoms/Button';

import { socket } from 'app/socket';
import {
  CreateNotification,
  NotificationType,
} from 'interfaces/Notification.interface';
interface VideoProps {
  url: string;
  data: OtrData;
  setCurrentIndex: SetStateAction<any>;
  currentIndex: number;
  scrollDown?: (amount: number) => void;
  autoScroll: boolean;
  setAutoScroll: SetStateAction<any>;
  otr: OtrData;
}

const Video: React.FC<VideoProps> = ({
  url,
  data,
  setCurrentIndex,
  currentIndex,
  scrollDown,
  autoScroll,
  setAutoScroll,
  otr,
}) => {
  const [menuShow, setMenuShow] = useState<boolean>(true);
  const videoRef = useRef<HTMLVideoElement>(null);
  const authState = useAppSelector(selectAuth);
  const [liked, setLiked] = useState<boolean>(false);
  const dispatch = useAppDispatch();
  const [onStart, onEnd] = useLongPress(() => setMenuShow(!menuShow), 500);
  const broom = require('assets/broom.png');
  const otrState = useAppSelector(selectOtr);

  const toggleLike = async () => {
    try {
      if (otrState.otrs && authState.id) {
        if (liked) {
          setLiked(false);
        } else {
          setLiked(true);
        }
        dispatch(addLike({ id: authState.id, currentIndex }));
        await updateOtr({
          id: otrState.otrs[currentIndex].id,
          likes: [authState.id],
        });

        if (socket && otr.id) {
          console.log(socket.emit)
          const likeNotificationOtr: CreateNotification = {
            fromId: authState.id,
            toId: otr.user.id,
            notificationType: NotificationType.LIKE,
            nftId: otr.id,
          };
          socket.emit('notification', likeNotificationOtr);
        }
      }
  } catch (error) {
      console.log(error);
      setLiked(false);
    }
  };

  const swipeUp = async () => {
    if (otrState.otrs) {
      if (currentIndex < otrState.otrs.length - 1) {
        setCurrentIndex((prev: number) => prev + 1);
      } else {
        setCurrentIndex(0);
      }
      try {
        await increaseOtrView(otrState.otrs[currentIndex].id);
      } catch (error) {
        console.log(error);
      }
    }
  };

  useEffect(() => {
    let options = {
      rootMargin: '0px',
      threshold: [0.25, 0.75],
    };

    let handlePlay = (entries: any, observer: any) => {
      entries.forEach((entry: any) => {
        if (entry.isIntersecting && videoRef.current) {
          videoRef.current.play();
        } else if (videoRef.current) {
          videoRef.current.pause();
        }
      });
    };

    let observer = new IntersectionObserver(handlePlay, options);
    if (videoRef.current) observer.observe(videoRef.current);
  }, []);

  const navigate = useNavigate();
  const handlers = useSwipeable({
    onSwipedLeft: eventData => {
      if (window.innerHeight > window.innerWidth) {
        if (document?.fullscreenElement) {
          document.exitFullscreen();
        }
        navigate(`/otrauction/${data.id}`);
      }
    },
    trackMouse: true,
    onSwipedUp: async event => swipeUp(),
    onSwipedDown: event => {
      if (otrState.otrs) {
        if (currentIndex > 0) {
          setCurrentIndex((prev: number) => prev - 1);
        } else {
          setCurrentIndex(otrState.otrs.length - 1);
        }
      }
    },
  });

  React.useEffect(() => {
    const videoElem = document.querySelector('.video');
    if (videoElem) {
      videoElem.addEventListener('contextmenu', event =>
        event.preventDefault()
      );
    }
  }, []);

  useEffect(() => {
    if (otrState.otrs) {
      window.history.replaceState(
        null,
        'Buku',
        `/explore/otr/${otrState.otrs[currentIndex].id}`
      );
    }
  }, [currentIndex, otrState.otrs]);

  return (
    <div className="main__video__cont" {...handlers}>
      <Grid
        style={{
          width: '70%',
          display: 'flex',
          position: 'absolute',
          zIndex: '1000',
          margin: '20px 15%',
          justifyContent: 'space-around',
        }}
      >
        <NormalButton
          onClick={() => {
            navigate(`/explore/nft/${data.id}`);
          }}
          sx={{
            width: '110px',
            height: '47px',
          }}
        >
          Explore NFT
        </NormalButton>
        <NormalButton
          onClick={() => {
            navigate(`/explore/otr/${data.id}`);
          }}
          sx={{
            width: '110px',
            height: '47px',
            backgroundColor: '#ccaf35',
          }}
        >
          Explore OTR
        </NormalButton>
      </Grid>
      <div className="video" onTouchStart={onStart} onTouchEnd={onEnd}>
        <IconButton
          sx={{
            position: 'fixed',
            top: 20,
            left: 20,
            zIndex: 99,
            color: 'white',
          }}
          onClick={() => navigate('/')}
        >
          <ArrowBackIosNewIcon />
        </IconButton>
        <video
          contextMenu="return false;"
          className="video__player"
          poster={url}
          src={url}
          ref={videoRef}
          muted={true}
          playsInline
          controlsList="nodownload"
          onEnded={
            scrollDown ? () => scrollDown(currentIndex * 100) : undefined
          }
        ></video>
        <div onClick={() => setMenuShow(!menuShow)} className="broom">
          <img
            src={broom}
            alt={'img'}
            style={{ width: '100%', height: '100%' }}
          />
        </div>
        {otrState.otrs && <VideoSidebar
          isLiked={liked}
          toggleLike={toggleLike}
          data={data}
          className={`${menuShow && 'active'}`}
          autoScroll={autoScroll}
          setAutoScroll={setAutoScroll}
          otrIndex = {currentIndex}
        />}
      </div>
    </div>
  );
};

export default Video;
